exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".module-section-container {\n  margin: 20px 0 30px; }\n\n.module-section-header {\n  border-bottom: 2px solid #34b3e8;\n  text-transform: uppercase;\n  font-size: 14px;\n  font-weight: bold;\n  padding: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/dominik/Documents/projekty/guru-apps-saas/src/app/shared/module-section/module-section.component.scss
// module id = ../../../../../src/app/shared/module-section/module-section.component.scss
// module chunks = 1